exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".studentReportModal .evaluationContainer .extraCoinsText,.studentReportModal .evaluationContainer .initialInstructions{text-align:center}.studentReportModal .evaluationContainer .selfEvaluationForm .labelsContainer{width:60%;margin:auto}.studentReportModal .evaluationContainer .selfEvaluationForm .labelsContainer label{display:block}.studentReportModal .evaluationContainer .selfEvaluationForm .labelsContainer label input{margin-right:5px}.studentReportModal .evaluationContainer .selfEvaluationForm .evaluationTextArea{width:75%;margin:auto;margin-bottom:15px}.studentReportModal .evaluationContainer .selfEvaluationForm .extraCoinsText{font-size:.8em;margin-top:10px;margin-bottom:15px}.studentReportModal .evaluationContainer .selfEvaluationForm .buttonSuccess{display:block;margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/students/student_report_modal.scss
// module id = 1406
// module chunks = 0